// AppId.ts

// Various type of application IDs
export enum AppIdType {
    Unknown =0,

    // Application ID types
    Patient,
    PatientEntity,
    Order,

    // Pseudo ID type
    StartOfPseudoIDs = 1000*1000,
    TabName 
}

// Tuple of application ID and ID type
export interface IAppId
{
    value: any;
    type: AppIdType;
}

export class AppId implements IAppId {
    type: AppIdType;
    value: any;

    constructor (type: AppIdType, value: any){
        this.type = type;
        this.value = value;
    }

    // Return a value without an AppId
    public static Empty(): AppId {
        return new AppId(AppIdType.Unknown, null);
    }
}


export class AppIDs {
    appIDs: IAppId[];

    public constructor(args: IAppId[] | IAppId | undefined)
    {
        if (Array.isArray(args))
            this.appIDs = args;
        else if (args)
            this.appIDs = [args];
        else
            this.appIDs = [];
    }

    public ValuesByType(idType: AppIdType): IAppId[] {
        return this.appIDs.filter(val => val.type == idType);
    }    

    public ValueByType(idType: AppIdType): IAppId | undefined {
        const filteredValues = this.appIDs.filter(val => val.type == idType);
        if (filteredValues.length > 1)
        {
            alert(`More than one value of type ${idType} was found`)
            return;
        }
        return filteredValues[0];
    }    

    // Get a single AppId
    public GetSingleAppId(): IAppId | undefined
    {
        const idValues = this.GetAppIDValues();
        if (1 !== idValues.length)
        {
            alert(`Wrong number of AppId values: ${idValues.length}`);
            return;
        }
        return idValues[0];
    }   

    public GetAppIDValues(): IAppId[] {
        return this.appIDs.filter(val => val.type > AppIdType.Unknown  || val.type < AppIdType.StartOfPseudoIDs);
    }
    
}